import { cn } from '@/lib/utils';

interface SkillBadgeProps {
  skill: string;
  variant?: 'match' | 'gap' | 'neutral';
}

const variants = {
  match: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  gap: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  neutral: 'bg-secondary text-secondary-foreground'
} as const;

export function SkillBadge({ skill, variant = 'neutral' }: SkillBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        variants[variant]
      )}
    >
      {skill}
    </span>
  );
}
